import { personalInfoQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useRemoveTwoFactor() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: () => api.post('/api/v1/security/disable-2factor-auth', void 0),
    successLogAction: () => ({ ActionType: ActionType.DisableTwoFactorAuth }),
    errorLogAction: () => ({ ActionType: ActionType.DisableTwoFactorAuth }),
    onSuccess: (_res, _input, _mutateRes, { client }) => {
      client.setQueryData(personalInfoQueryOptions.queryKey, (old) =>
        old ? { ...old, TwoFactorAuthEnabled: false } : old,
      );
      toast.show('success', t('Common.SnackBar.TwoFactorAuthDisabled'));
    },
  });
}
